import React, { useState } from 'react';
import { formatItemDate, getStatus } from "../../helpers/";
import { useSelector } from 'react-redux';
import AddActivity from '../AddActivity';

const ScrollItem = (props) => {

    const dependencies = useSelector(state => state.dependencies);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);

    const handleShow = function (event) {
        event.preventDefault();
        setShow(true);
    };

    return (

        <React.Fragment>
            <tr onClick={handleShow}>

                <td>{formatItemDate(props.activity.finish)}</td>
                <td>{props.activity.name}</td>
                <td className="owner">{props.activity.users ?
                    props.activity.users[0].name.charAt(0) + props.activity.users[0].surname.charAt(0) : ''
                }
                </td>
                <td><div className={`status ${getStatus(props.activity, dependencies)}`}></div></td>


            </tr>
            <AddActivity show={show} onHide={handleClose} item={props.activity} dependencies={dependencies} deliverable={props.deliverable} />
        </React.Fragment>
    )
}

export default ScrollItem;